import React, { useEffect } from "react";


const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
<h2 className="flex justify-center text-center mt-10 mb-10">Coming Soon</h2>
</div>
  );
}

export default About;
